export const calendarLayout = {
    minWidth: 332,
    monthViewportWidth: 284,
    monthViewportMinHeight: 268,
    weekNumberWidth: 28,
    dayCellSize: 36,
    weekdayHeaderHeight: 28,
    selectorYearColumnWidth: 96,
    selectorMinHeight: 248,
    selectorMonthMinHeight: 40,
    transitionDurationMs: 220,
    contentGap: 2,
    sectionGap: 1,
    compactGap: 0.5,
} as const;
